import { CheckCircle2 } from 'lucide-react';
import {
  ResumeCard,
  ResumeCardHeader,
} from '@/components/commercial/proposals/shared/summary-components';
import { formatDateTime } from '@/lib/formatters';
import { ContractRecipientCard } from './contract-recipient-card';
import type { ContractViewData } from './contract-state';
import { ContractStatusBadge } from './contract-status-badge';

interface ContractSignedStateProps {
  contract: ContractViewData;
}

export function ContractSignedState({ contract }: ContractSignedStateProps) {
  const signedAtFormatted = contract.signedAt ? formatDateTime(contract.signedAt) : null;

  return (
    <div className="space-y-5">
      <ResumeCard>
        <ResumeCardHeader
          title="Assinatura eletrônica do contrato"
          icon={<CheckCircle2 className="h-4 w-4 text-green-600" />}
        />
        <div className="space-y-4 px-5 py-5">
          <div className="flex items-start gap-3">
            <div className="flex h-9 w-9 flex-none items-center justify-center rounded-full bg-green-50">
              <CheckCircle2 className="h-5 w-5 text-green-600" aria-hidden="true" />
            </div>
            <div className="min-w-0 space-y-1">
              <p className="text-sm font-semibold text-gray-900">Assinatura concluída!</p>
              <p className="text-xs text-gray-500">
                O contrato foi assinado eletronicamente e está disponível para prosseguir.
              </p>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <ContractStatusBadge status={contract.status} />
            {signedAtFormatted && (
              <p className="text-xs text-gray-500">
                Concluída em{' '}
                <span className="font-semibold text-gray-700 tabular-nums">
                  {signedAtFormatted}
                </span>
              </p>
            )}
          </div>
        </div>
      </ResumeCard>

      <ContractRecipientCard signerEmail={contract.signerEmail} signerName={contract.signerName} />
    </div>
  );
}
